import { domain_vizr } from "../../redux/constants/constants";

export const fetchTotalDataTagFilesAPI = `${domain_vizr}/tenant/dataTag/totalFiles`;
export const fetchDataTagDashboardTotalCountAPI = `${domain_vizr}/tenant/dataTag/totalFiles`;
export const fetchDataEstateAPI = `${domain_vizr}/tenant/dataTag/dataEstate/summary`;
export const fetchDataTagFileClassificationsAPI = `${domain_vizr}/tenant/dataTag/FileClassifications`;
export const fetchDataTagSensitiveAndRegulatedDataAPI = `${domain_vizr}/tenant/dataTag/sensitiveAndRegulatedData`;
export const fetchDataTagDuplicateFileDataAPI = `${domain_vizr}/tenant/dataTag/duplicateFileData`;
export const fetchDataTagMetadataAPI = `${domain_vizr}/tenant/dataTag/metadata/completeness`;
export const fetchDataTagDataAccessibilityAPI = `${domain_vizr}/tenant/dataTag/getFileInsights`;
export const SET_TOTAL_DATA_TAG_FILES = "FETCH_TOTAL_DATA_TAG_FILES";
export const SET_DATA_TAG_LOADING = "SET_DATA_TAG_LOADING";
export const FETCH_DATA_TAG_DASHBOARD_DATA = "FETCH_DATA_TAG_DASHBOARD_DATA";
export const SET_DATA_ESTATE = "SET_DATA_ESTATE";
export const SET_DATA_TAG_FILE_CLASSIFICATIONS =
  "SET_DATA_TAG_FILE_CLASSIFICATIONS";
export const SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA =
  "SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA";
export const SET_DATA_TAG_DUPLICATE_FILE_DATA =
  "SET_DATA_TAG_DUPLICATE_FILE_DATA";
export const SET_DATA_TAG_METADATA = "SET_DATA_TAG_METADATA";
export const SET_DATA_TAG_ACCESSIBILITY = "SET_DATA_TAG_ACCESSIBILITY";
export const RESET_DATA_TAG_STATE = "RESET_DATA_TAG_STATE";
export const SET_DATA_TAG_NODES_DATA = "SET_DATA_TAG_NODES_DATA";
export const FETCH_DATA_TAG_ALL_FILES = "FETCH_DATA_TAG_ALL_FILES";
export const SET_DATA_TAG_ALL_FILES = "SET_DATA_TAG_ALL_FILES";
export const SET_SELECTED_DATA_TAG_SOURCE_ID =
  "SET_SELECTED_DATA_TAG_SOURCE_ID";
export const fetchDataTagAllFilesAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/files?dataSourceId=${dataSourceId}`;
};
export const FETCH_ALL_DATA_SOURCES_API_DATA_TAG =
  "FETCH_ALL_DATA_SOURCES_API_DATA_TAG";
export const SET_ALL_DATA_TAG_SOURCES = "SET_ALL_DATA_TAG_SOURCES";
// Centralized color mapping for classification types
export const CLASSIFICATION_COLORS = {
  MARKETING: "#FF8A65",
  FINANCIAL: "#AA46BE",
  PERSONAL: "#2B43FF",
  ORGANIZATIONAL: "#00C49F",
  API: "#42A5F5",
  MEDICAL: "#EF5350",
  NO_SENSITIVITY: "#FFBB28",
  OTHER: "#8D8D8D",
  NOT_PROCESSED: "#7E57C2",
};

export const FETCH_DATA_TAG_USERS = "FETCH_DATA_TAG_USERS";
export const SET_DATA_TAG_USERS = "SET_DATA_TAG_USERS";
export const fetchDataTagUsersAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/usersByFileCount?dataSourceId=${dataSourceId}`;
};
export const fetchDataEstateSummaryAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/${dataSourceId}/summary`;
};
export const FETCH_DATA_ESTATE_SUMMARY = "FETCH_DATA_ESTATE_SUMMARY";
export const SET_DATA_ESTATE_SUMMARY = "SET_DATA_ESTATE_SUMMARY";
export const fetchDataTagDrivesAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/driveSummary?dataSourceId=${dataSourceId}`;
};
export const FETCH_DATA_TAG_DRIVES = "FETCH_DATA_TAG_DRIVES";
export const SET_DATA_TAG_DRIVES = "SET_DATA_TAG_DRIVES";
export const FETCH_DATA_TAG_FILES = "FETCH_DATA_TAG_FILES";
export const SEARCH_DATA_TAG_FILES = `${domain_vizr}/tenant/dataTag/files/search`;
export const SET_SEARCHED_DATA_TAG_FILES = "SET_SEARCHED_DATA_TAG_FILES";
export const FETCH_DATA_TAG_USERS_LIST = "FETCH_DATA_TAG_USERS_LIST";
export const SET_SEARCHED_DATA_TAG_USERS = "SET_SEARCHED_DATA_TAG_USERS";

export const FETCH_SIZE_CARD_DATA = "FETCH_SIZE_CARD_DATA";
export const SET_SIZE_CARD_DATA = "SET_SIZE_CARD_DATA";

export const FETCH_SENSITIVE_SUMMARY_CARD_DATA =
  "FETCH_SENSITIVE_SUMMARY_CARD_DATA";
export const SET_SENSITIVE_SUMMARY_CARD_DATA =
  "SET_SENSITIVE_SUMMARY_CARD_DATA";

export const FETCH_CATEGORY_CARD_DATA = "FETCH_CATEGORY_CARD_DATA";
export const SET_CATEGORY_CARD_DATA = "SET_CATEGORY_CARD_DATA";

export const DATA_ESTATE_SUMMARY_LOADER = "DATA_ESTATE_SUMMARY_LOADER";

export function formatCount(num) {
  if (num >= 1_000_000_000_000) {
    // Trillions
    return Math.floor(num / 100_000_000_000) / 10 + "T";
  }
  if (num >= 1_000_000_000) {
    // Billions
    return Math.floor(num / 100_000_000) / 10 + "B";
  }
  if (num >= 1_000_000) {
    // Millions
    return Math.floor(num / 100_000) / 10 + "M";
  }
  if (num >= 1_000) {
    // Thousands
    return Math.floor(num / 100) / 10 + "K";
  }
  return num;
}

export const formatEpoch = (epoch) => {
  if (!epoch) return null;

  const d = new Date(Number(epoch));

  const MM = String(d.getMonth() + 1).padStart(2, "0");
  const DD = String(d.getDate()).padStart(2, "0");
  const YYYY = d.getFullYear();
  const HH = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");

  return `${MM}-${DD}-${YYYY} ${HH}:${mm}`;
};

export const POP_UP_LOCATION_KEY = "POP_UP_LOCATION_KEY";

export const fetchAllFileTypes = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/fileTypes?dataSourceId=${dataSourceId}`;
};
export const FETCH_ALL_FILE_TYPES_DATA = "FETCH_ALL_FILE_TYPES_DATA";
export const SET_ALL_FILE_TYPE_LIST = "SET_ALL_FILE_TYPE_LIST";
